import { OpaqueToken } from '@angular/core';
export var QUERY_DEFAULTS = new OpaqueToken('QUERY_DEFAULTS');
export function QueryDefaultsProvider(options) {
    if (options === void 0) { options = {}; }
    return {
        provide: QUERY_DEFAULTS,
        useValue: options
    };
}
//# sourceMappingURL=query-defaults.provider.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@zhongruigroup_ngx-query@1.0.1@@zhongruigroup/ngx-query/providers/query-defaults.provider.js
// module id = null
// module chunks = 